'use client';
var classes = {"root":"m-e615b15f","section":"m-599a2148"};

export default classes;
//# sourceMappingURL=Card.module.mjs.map
